import { render, staticRenderFns } from "./VulnDetails.vue?vue&type=template&id=12e537f3&scoped=true"
import script from "./VulnDetails.vue?vue&type=script&lang=js"
export * from "./VulnDetails.vue?vue&type=script&lang=js"
import style0 from "./VulnDetails.vue?vue&type=style&index=0&id=12e537f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e537f3",
  null
  
)

export default component.exports